import { noticeFailure, noticeSuccess } from "@self/notices";
import { makeStylesheetLink } from "../stylesheet";

export class NewsletterSubscription extends HTMLElement {
	shadow: ShadowRoot;
	button: HTMLButtonElement;
	input: HTMLInputElement;
	checkbox: HTMLInputElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button className="gct-btn-lg gct-flex-row gct-flex-cross-center gct-footer-newsletter"><small className="gct-text-nowrap gct-content-fit" value="clickme">
			<div className="gct-footer-show-object">Get Exclusive Offers</div>
			<div className="gct-footer-hide-object gct_footer_font_size" >&#8594;</div>
		</small></button> as HTMLButtonElement;

		this.input = <input type="text" id="newsletter-email" name="newsletter-email" placeholder=" " className="gct-w100 gct-footer-newsletter" size="50"></input> as HTMLInputElement

		this.checkbox = <input type="checkbox" id="terms-conditions" name="terms-conditions"></input> as HTMLInputElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			<div className="gct-flex-column gct-gap-16">
				<div className="gct-flex-row gct-footer-newsletter-container">
					<div className="gct-p-relative gct-w100">
						{this.input}
						<label htmlFor="newsletter-email">Enter your email</label>
					</div>
					{this.button}
				</div>
				<label className="gct-custom-checkbox">
					{this.checkbox}
					<span><small>I accept the Terms & Conditions</small></span>
				</label>
			</div>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick.bind(this));
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick.bind(this));
	}

}

async function onClick(this: NewsletterSubscription) {

	const matchEmailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const email = this.input.value;
	const consentToTerms = this.checkbox.checked;

	if (!email.match(matchEmailFormat)) {
		noticeFailure("Please provide vaild email address");
		return;
	}

	if (!consentToTerms) {
		noticeFailure("Please accept our Terms & Conditions");
		return;
	}

	try {

		const data = new URLSearchParams({
			action: "mailchimp_set_user_by_email",
			/* security: this.dataset.nonce!, */
			email: email,
			subscribed: "1",
		});

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			body: data,
		});

		const json = await res.json();

		if (json === null || typeof json !== "object" || !("result" in json) || !("applied" in json) || !("notices_html" in json) || typeof json.notices_html !== "string") {
			noticeFailure("There was an unexpected error.");
			return;
		} else {
			const notices = new DOMParser().parseFromString(json.notices_html, "text/html");
			const noticeText = notices.documentElement.textContent ?? "";
			(json.applied === "yes" ? noticeSuccess : noticeFailure)(noticeText);
		}

	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	}
}
